var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCogs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 126.804,
    height: 125.892,
    viewBox: "0 0 116.804 125.892",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.201,
    x2: 2.01,
    y2: 1.327,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#55a4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55a4ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_62503",
    x: 0,
    y: 0,
    width: 99.449,
    height: 99.449,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#07111a"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.194,
    y1: 0.21,
    x2: 1.461,
    y2: 1.187,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "Path_62503-2",
    x: 9.118,
    y: 8.206,
    width: 117.686,
    height: 117.686,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#07111a"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29769",
    "data-name": "Group 29769",
    transform: "translate(-68.5 -8.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29768",
    "data-name": "Group 29768",
    transform: "translate(94 34)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -25.5, -25.5)",
    filter: "url(#Path_62503)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62503-3",
    "data-name": "Path 62503",
    d: "M2586.931,1711.371V1705.9a1.623,1.623,0,0,0-1.624-1.624h-2.491a2,2,0,0,1-1.346-3.245c.9-1.013,3.271-2.517,1.764-4.06l-3.865-3.865a1.624,1.624,0,0,0-2.3,0l-1.763,1.763a2,2,0,0,1-3.245-1.347v-2.491a1.623,1.623,0,0,0-1.624-1.624h-5.467a1.624,1.624,0,0,0-1.624,1.624v2.491a2,2,0,0,1-3.245,1.347l-1.764-1.763a1.623,1.623,0,0,0-2.3,0l-3.865,3.865a1.624,1.624,0,0,0,0,2.3c1.013,1.146,3.023,2.24,1.917,4.009-.461,1.468-2.884.894-3.991,1a1.624,1.624,0,0,0-1.624,1.624v5.467a1.624,1.624,0,0,0,1.624,1.624c1.151.106,3.5-.471,3.991,1,1.118,1.753-.932,2.892-1.917,4.009a1.624,1.624,0,0,0,0,2.3l3.865,3.865a1.623,1.623,0,0,0,2.3,0l1.764-1.764a2,2,0,0,1,3.245,1.346v2.492a1.624,1.624,0,0,0,1.624,1.624h5.467c3.127-.15.307-4.687,2.623-5.615,1.753-1.118,2.892.932,4.009,1.917a1.624,1.624,0,0,0,2.3,0l3.865-3.865c2.167-2.549-3.684-3.633-1.917-6.3C2582.244,1711.68,2586.784,1714.5,2586.931,1711.371Zm-18.567,5.346c-10.594.8-11.851-15.238-1.315-16.158C2577.642,1699.759,2578.9,1715.8,2568.364,1716.717Z",
    transform: "translate(-2522.98 -1663.91)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29767",
    "data-name": "Group 29767",
    transform: "translate(103.118 42.206)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -34.62, -33.71)",
    filter: "url(#Path_62503-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62503-4",
    "data-name": "Path 62503",
    d: "M2605.167,1721.785v-8.059a2.394,2.394,0,0,0-2.394-2.394H2599.1c-2.2.036-3.57-3.252-1.985-4.784,1.333-1.494,4.822-3.71,2.6-5.985l-5.7-5.7a2.394,2.394,0,0,0-3.385,0l-2.6,2.6c-1.53,1.58-4.821.217-4.783-1.985v-3.673a2.394,2.394,0,0,0-2.394-2.394h-8.059a2.394,2.394,0,0,0-2.394,2.394v3.673c.036,2.2-3.252,3.57-4.783,1.985l-2.6-2.6a2.394,2.394,0,0,0-3.385,0l-5.7,5.7a2.394,2.394,0,0,0,0,3.385c1.493,1.69,4.458,3.3,2.826,5.91-.679,2.164-4.252,1.318-5.885,1.473a2.394,2.394,0,0,0-2.394,2.394v8.059a2.394,2.394,0,0,0,2.394,2.394c1.7.156,5.16-.694,5.884,1.474,1.648,2.584-1.374,4.264-2.826,5.91a2.394,2.394,0,0,0,0,3.385l5.7,5.7a2.394,2.394,0,0,0,3.385,0l2.6-2.6c1.53-1.58,4.822-.217,4.783,1.985v3.673a2.394,2.394,0,0,0,2.394,2.394h8.059c4.61-.222.453-6.911,3.867-8.278,2.584-1.648,4.264,1.374,5.91,2.826a2.393,2.393,0,0,0,3.385,0l5.7-5.7c3.194-3.757-5.431-5.357-2.826-9.3C2598.257,1722.241,2604.95,1726.395,2605.167,1721.785Zm-27.373,7.882c-15.618,1.179-17.472-22.465-1.938-23.823C2591.473,1704.666,2593.327,1728.31,2577.794,1729.667Z",
    transform: "translate(-2513.86 -1655.71)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient-2)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCogs);
export default __webpack_public_path__ + "static/media/cogs.45d7c48258367498af11318fb0bfa85f.svg";
export { ForwardRef as ReactComponent };